import { el } from '../../core/dom.js';
import { button } from '../../components/button.js';
import { dashboardHref, offlineCopy } from './model.js';

/**
 * Offline screen (plan 4 R11). Retry probes /health; online event reloads.
 * @param {{ productId?: string }} [opts]
 */
export function renderOffline(opts) {
  const productId = (opts && opts.productId) || '';
  const copy = offlineCopy();
  const status = el('div', { class: 'st-status' }, 'Connection lost');
  const retryBtn = button(copy.retryLabel, {
    variant: 'primary',
    onClick: () => retry(retryBtn, status),
  });

  const root = el('div', { class: 'st' },
    el('div', { class: 'st-card' },
      el('span', { class: 'st-kicker lbl' }, copy.kicker),
      el('h1', { class: 'st-title' }, copy.title),
      el('p', { class: 'st-body' }, copy.body),
      status,
      el('div', { class: 'st-actions' },
        retryBtn,
        button(copy.homeLabel, {
          href: dashboardHref(productId),
        })),
      el('p', { class: 'st-note' }, copy.note)));

  function onOnline() {
    status.className = 'st-status is-online';
    status.textContent = 'Back online - refreshing…';
    setTimeout(() => { window.location.reload(); }, 800);
  }

  window.addEventListener('online', onOnline);
  root.addEventListener('bonnie:unmount', () => {
    window.removeEventListener('online', onOnline);
  });

  return root;
}

async function retry(btn, status) {
  const label = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Trying…';
  try {
    const resp = await fetch('/health', { method: 'HEAD', cache: 'no-store' });
    if (resp.ok) {
      status.className = 'st-status is-online';
      status.textContent = 'Back online - refreshing…';
      window.location.reload();
      return;
    }
  } catch { /* still offline */ }
  btn.disabled = false;
  btn.textContent = label;
  status.className = 'st-status';
  status.textContent = 'Still offline';
}

/**
 * Compact banner for the shell when the browser goes offline mid-session.
 * @param {{ onOpen?: () => void }} [opts]
 */
export function offlineBanner(opts) {
  return el('div', {
    class: 'st-banner',
    role: 'status',
  },
  el('span', {}, "You're offline - some data may be stale."),
  opts && opts.onOpen
    ? el('button', {
      type: 'button',
      class: 'st-banner-link',
      onClick: opts.onOpen,
    }, 'Details')
    : null);
}
